import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { ZEFFY_DONATE_URL, ZEFFY_5K_URL } from "@/lib/api";

export default function Footer() {
    return (
        <footer className="bg-brand-navy text-stone-100 mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="font-serif text-2xl">Poppa &amp; Gigi&apos;s <span className="font-accent text-brand-lime-light text-3xl">Promise</span></div>
                    <p className="mt-3 text-sm text-stone-300 max-w-xs leading-relaxed">
                        Uplifting grandparents and kinship caregivers raising the next generation.
                    </p>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-stone-400 mb-4">Quick Links</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/register" className="hover:text-brand-lime-light" data-testid="footer-link-register">Register</Link></li>
                        <li><Link to="/sponsor" className="hover:text-brand-lime-light" data-testid="footer-link-sponsor">Become a Sponsor</Link></li>
                        <li><Link to="/volunteer" className="hover:text-brand-lime-light" data-testid="footer-link-volunteer">Volunteer</Link></li>
                        <li><Link to="/send-note" className="hover:text-brand-lime-light" data-testid="footer-link-send-note">Send a Note</Link></li>
                        <li><a href={ZEFFY_DONATE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-lime-light" data-testid="footer-link-donate">Donate</a></li>
                        <li><a href={ZEFFY_5K_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-lime-light" data-testid="footer-link-5k">5K Run Info</a></li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-stone-400 mb-4">Connect</div>
                    <a
                        href="https://instagram.com/grandfamilydiaries"
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-3 text-sm hover:text-brand-lime-light mb-2"
                        data-testid="footer-instagram"
                    >
                        <Instagram size={18} /> @grandfamilydiaries
                    </a>
                    <a
                        href="mailto:Burdette@poppaandgigispromise.org"
                        className="flex items-center gap-3 text-sm hover:text-brand-lime-light break-all"
                        data-testid="footer-email"
                    >
                        <Mail size={18} className="shrink-0" /> Burdette@poppaandgigispromise.org
                    </a>
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-xs text-stone-400 tracking-wide">
                © {new Date().getFullYear()} Poppa &amp; Gigi&apos;s Promise · Stories Woven In Grain · <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-brand-lime-light">Admin</Link>
            </div>
        </footer>
    );
}
